import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Cloning extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_vegetative_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Cloning
        </h2>
        <p>
        Cloning is the process of taking cuttings from a marijuana plant and re-planting them so they turn into their own plants. Clones will be a genetic copy of the parent plant, however you may notice alterations in your strain or potency after many generations of cloning. 
        </p>
        <h3>What to look for in a clone</h3>
        <p>
        The ideal clone is 5 to 10 inches tall and features a good stem and at least one node with branches. Essentially look for a tiny weed plant. Use a clean pair of scissors to cut the plant. Cutting the stem at an angle will provide more rooting space for the plant. Scuffing up the cut stem slightly can also help. Immediately transfer the clone to water. Next dip the clones stem in rooting gel, which provides the hormones needed for the plant to begin behaving as a root. After dipping in rooting gel move the plant into a small container filled with so. A solo cup works perfectly. Water the plant and place a ziploc bag with holes cut in it loosely over the plant. Water the inside of the bag to create a tiny humid greenhouse. 
        </p>
        <p>
        In the coming weeks your plant should root and begin showing new growth. Once you’re confident the plant is rooted and happy you can move it to a bigger container. 
        </p>
        <h3>
        Mother Plants
        </h3>
        <p>
        A mother plant is a marijuana plant kept for the sole purpose of preserving a strain and taking clones. As long you keep your plant in the vegetative stage and never let it flower, it should live indefinitely, allowing you to take clones from the plant on a regular basis. The reason you keep a mother plant, instead of just cloning your clones, is that subsequent generations of cloning can alter or weaken your strain, meaning clones from your mother plant will be more hearty, reliable and consistent during every grow.
        </p>
        <GuideButton slugTo="topping" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/three_cloning.js